module.exports = __webpack_public_path__ + "static/media/addPhoto.ad4445ef.svg";